import App from './App.svelte';

const app = new App({
	target: document.getElementById("main")
});

export default app;